import { BundleResourceService } from './services/bundle-resource.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ChannelAddAssociationsComponent } from './components/associations/channel-add-associations/channel-add-associations.component';
import { ChannelAddGroupAssociationsComponent } from './components/associations/channel-add-group-associations/channel-add-group-associations.component';
import { ChannelAddOrgAssociationsComponent } from './components/associations/channel-add-org-associations/channel-add-org-associations.component';
import { ChannelAddAssociationService } from './services/channel-add-association.service';
import { ChannelHeaderComponent } from './components/channel-header/channel-header.component';
import { LayoutModule } from '@app/layout/layout.module';
@NgModule({
  declarations: [
    ChannelAddAssociationsComponent,
    ChannelAddGroupAssociationsComponent,
    ChannelAddOrgAssociationsComponent,
    ChannelHeaderComponent,
  ],
  imports: [CommonModule, SharedModule, LayoutModule],
  exports: [
    ChannelAddGroupAssociationsComponent,
    ChannelAddOrgAssociationsComponent,
    ChannelHeaderComponent,
  ],
  providers: [BundleResourceService, ChannelAddAssociationService],
})
// TODO: This could be put in shared, or keep as it's own module until it's not needed in learner-experience module
export class ChannelHeaderModule {}
